import { CouponApplyErrorCode } from "../../../core/enums";
import { CouponApplyPhase } from "../interfaces/coupon-qualifier.interface";
export class BaseTriggerItemsQualifier {
    phase = CouponApplyPhase.PreApply;
    _data;
    _cartItems = [];
    _triggerItems = [];
    constructor(sourceData) {
        this._data = sourceData;
    }
    get qualifiedItems() {
        return this._triggerItems;
    }
    qualify(coupon, cart) {
        const baseQualification = BaseTriggerItemsQualifier.validateBaseTriggerItemsRequirement(coupon, cart);
        if (!baseQualification.isValid)
            return baseQualification;
        this._cartItems = structuredClone(cart.items);
        const triggerItems = this._getTriggerItems(coupon, cart);
        const post = this._postValidate(coupon, cart, triggerItems);
        if (!post.isValid)
            return post;
        this._triggerItems = triggerItems;
        return { isValid: true, errorCode: null };
    }
    // Hook for mix-match / variants
    _postValidate(_coupon, _cart, triggerItems) {
        if (triggerItems.length === 0) {
            return { isValid: false, errorCode: CouponApplyErrorCode.NO_QUALIFYING_ITEMS };
        }
        return { isValid: true, errorCode: null };
    }
    static validateBaseTriggerItemsRequirement(coupon, cart) {
        if (!coupon.isQualifiedItemsRequired)
            return { isValid: true, errorCode: null };
        if (coupon.items.length === 0)
            return { isValid: false, errorCode: CouponApplyErrorCode.NO_QUALIFYING_ITEMS };
        const qualifyingIds = new Set(coupon.items.flatMap(x => x.itemId));
        if (!cart.items.some(item => qualifyingIds.has(item.id))) {
            return { isValid: false, errorCode: CouponApplyErrorCode.NO_QUALIFYING_ITEMS };
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=base-trigger-items.js.map